<template>
  <div class="field-wrapper">
    <div
      class="h-100 v-100 due-date-field d-flex justify-content-center align-items-baseline"
      tabindex="0"
      @keydown.esc.down="hideDatePicker"
      @keydown.space.enter.prevent="showDatePicker"
      ref="dateCell"
      :id="'due-date-picker-' + id"
    >
      <date-value
        :prevent-color-coding="isSettled"
        :value="initiative.dueDate"
        @clear="updateInitiative({ dueDate: null })"
        v-if="initiative.dueDate"
      />
      <span class="placeholder badge-default py-0" v-else>Due</span>
    </div>
    <b-popover
      ref="datePopover"
      placement="bottom"
      custom-class="due-date-po"
      triggers="click blur"
      :target="'due-date-picker-' + id"
    >
      <date-picker :value="initiative.dueDate" @input="onDueDateChange" />
    </b-popover>
  </div>
</template>

<script>
import DatePicker from '@/components/form/DatePicker'
import DateValue from '@/components/initiative/DateValue.vue'
import { STATUS } from '@/constants/initiative'
import random from '@/utils/random'
import { BPopover } from 'bootstrap-vue'

export default {
  name: 'DueDateField',
  props: ['initiative'],
  data() {
    return {
      id: random(5)
    }
  },
  components: {
    DatePicker,
    BPopover,
    DateValue
  },
  computed: {
    isSettled() {
      return this.initiative.isClosed || this.initiative.status === STATUS.completed.id
    }
  },
  methods: {
    hideDatePicker() {
      this.$refs.datePopover.$emit('close')
    },
    showDatePicker() {
      this.$refs.datePopover.$emit('open')
    },
    onDueDateChange(dueDate) {
      this.hideDatePicker()
      this.updateInitiative({ dueDate })
    },
    updateInitiative(payload) {
      this.$emit('update', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.due-date-field {
  cursor: pointer;

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    background: #edf8fe;

    button {
      border-color: transparent;
    }
  }
}

.date-badge {
  position: relative;
  white-space: nowrap;

  &:hover .close-icon {
    opacity: 1;
  }
}

.close-icon {
  box-shadow: $iconShadow;
  background-color: $documentColor;
  border-radius: 50%;
  padding: 8px;
  background-position: center;
  position: absolute;
  right: 0px;
  top: 0px;
  transform: translate3d(60%, -50%, 0);
  opacity: 0;
  transition: opacity ease-out 200ms;
}

.field-wrapper {
  display: contents;
}

.placeholder {
  opacity: 0;
  transition: opacity ease-in 200ms;
}
.due-date-field:hover .placeholder {
  opacity: 1;
}
@include media-breakpoint-down(md) {
  .placeholder {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.due-date-po .popover-body {
  padding: 0;
}
</style>
